// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TQjF","clinicsSelect":"styles_clinicsSelect__2H747"};